import React from 'react';
import { motion } from 'framer-motion';

const Hook = () => {
  return (
    <section className="bg-white py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center"
        >
          {/* Left: text */}
          <div className="max-w-2xl">
            <div className="flex items-center gap-4 mb-8">
              <div className="w-14 h-14 rounded-2xl bg-red-50 flex items-center justify-center border border-red-100">
                <svg className="w-7 h-7 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
              </div>
              <div>
                <p className="text-xs font-bold text-red-600 uppercase tracking-widest">The Blind Spot</p>
                <p className="text-sm text-gray-500 font-medium mt-0.5">Most leaders miss this.</p>
              </div>
            </div>

            <h2 className="text-3xl lg:text-4xl font-bold text-jeruel-dark mb-6 leading-tight">
              The wrench-turners are safe.<br/>
              <span className="text-jeruel-primary">The knowledge workers are not.</span>
            </h2>
            
            <p className="text-lg leading-relaxed text-gray-600 font-medium mb-8">
              Andrej Karpathy scored every job in America on a 0 to 10 AI exposure scale. When we isolated the 19 roles that drive maintenance and reliability, a clear picture emerged for organizations that aren't prepared.
            </p>
            
            <div className="pl-6 border-l-4 border-jeruel-primary bg-jeruel-offwhite p-6 rounded-r-xl mb-8">
              <p className="text-xl leading-relaxed font-bold text-jeruel-dark">
                Your industrial mechanics face a massive supply crisis, and they are virtually immune to AI. But your planners, CMMS admins, and reliability engineers are squarely in the crosshairs of automation.
              </p>
            </div>

            <a 
              href="#download-form"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-xl bg-jeruel-primary hover:bg-jeruel-light text-white font-bold text-base transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1"
            >
              See Which Roles Are Most Exposed
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </a>
          </div>

          {/* Right: Photographic Image */}
          <div className="relative">
            <div className="absolute inset-0 bg-jeruel-primary rounded-2xl transform translate-x-4 translate-y-4 opacity-20"></div>
            <img 
              src="https://images.unsplash.com/photo-1581092160562-40aa08e78837?auto=format&fit=crop&q=80&w=1000" 
              alt="Industrial engineer looking at tablet" 
              className="relative rounded-2xl shadow-xl w-full h-[500px] object-cover border border-jeruel-gray"
            />
            {/* Overlay tag */}
            <div className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur-sm p-4 rounded-xl shadow-lg border border-gray-100 flex items-center justify-between">
              <div>
                <p className="text-xs font-bold text-gray-500 uppercase">Role Analysis</p>
                <p className="text-sm font-bold text-jeruel-dark">Reliability Engineer</p>
              </div>
              <div className="text-right">
                <p className="text-xs font-bold text-jeruel-primary uppercase">Exposure Score</p>
                <p className="text-lg font-bold text-jeruel-dark">7.5 / 10</p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hook;